
export default class SafeList {

    constructor(compare) {
        this.array = [];
        this.iterationList = [];
        this.compare = compare ? compare : (u, v) => u === v;
    }

    size()  {
        return this.array.length;
    }

    add(element)    {
        this.array.push(element);
    }

    addUnique(element)    {
        if(this.array.findIndex(e => { return this.compare(e, element); }) >= 0) return;
        this.array.push(element);
    }

    remove(element)    {
        var index = this.array.findIndex(e => { return this.compare(e, element); });
        if(index < 0) return;
        this.array.splice(index, 1);

        for(var i = 0; i < this.iterationList.length; ++i)  {
            var indexObj = this.iterationList[i];
            if(index <= indexObj.index) indexObj.index--;
        }
    }

    removeAll() {
        this.iterationList.forEach(indexObj => { indexObj.index = 0; });
        this.array = [];
    }

    forEach(callback)   {
        var indexObj = {index: 0};
        this.iterationList.push(indexObj);

        while(indexObj.index < this.array.length) {
            callback(this.array[indexObj.index], indexObj.index);
            indexObj.index = indexObj.index + 1;
        }

        var index = this.iterationList.findIndex(e => e === indexObj);
        if(index < 0) return;
        this.iterationList.splice(index, 1);
    }
};